import React from 'react';
import styled from 'styled-components';
import { scrollToAnchor } from 'utils';

function Aside({
  anchors,
  activeAsideButtonIndex,
  setActiveAsideButtonIndex,
  setAsideButtonManuallyClicked
}) {
  return (
    <Container>
      {anchors.map((anchor) => (
        <AnchorItem
          key={anchor.id}
          tabIndex={0}
          role="button"
          smallerAnchor
          active={activeAsideButtonIndex === `${anchor.id}-section`}
          onClick={() => {
            setAsideButtonManuallyClicked(true);
            setActiveAsideButtonIndex(`${anchor.id}-section`);
            scrollToAnchor(`${anchor.id}-section`);
            setTimeout(() => setAsideButtonManuallyClicked(false), 1000);
          }}
          highlightColor={anchor.highlightColor}>
          {anchor.id}
        </AnchorItem>
      ))}
    </Container>
  );
}

const Container = styled.aside`
  align-self: start;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  height: auto;
  margin-bottom: 4.969rem;
  position: sticky;
  top: 2.563rem;
  width: 100%;
`;

const AnchorItem = styled.div`
  border: ${({ active }) => (active ? 'none' : '1px solid var(--ax-gold)')};
  border-radius: 2px;
  background-color: ${({ active, highlightColor }) =>
    active ? highlightColor : 'transparent'};
  cursor: pointer;
  font-size: 1.5rem;
  font-weight: 700;
  color: ${({ active }) => (active ? 'var(--ax-white)' : '#c1beac')};
  text-decoration: none;
  transition: 150ms ease-in-out;
  height: 2.5rem;
  width: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    border: none;
    background-color: ${({ highlightColor }) => highlightColor};
    color: var(--ax-white);
  }
  @media (min-width: 67.5rem) {
    font-size: 2rem;
    width: 3.5rem;
    height: 3.5rem;
  }
`;

export default Aside;
